// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function () {

  // js-gallery-slider
  if (document.querySelector('.js-gallery-slider')) {
    const swiper = new Swiper('.js-gallery-slider', {
      loop: true,
      speed: 20000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      slidesPerView: 1.2,
      spaceBetween: 10,
      loopAdditionalSlides: 5,

      // ブレークポイント（画面幅による設定）
      breakpoints: {
        569: {
          slidesPerView: 3,
          spaceBetween: 15
        },
        769: {
          slidesPerView: 3.5,
          spaceBetween: 20
        }
      },
    });
  }

})